<template>
  <div class="medical-record-header">
    <div class="loading tile tile-centered" v-if="loading" />
    <div class="header-grid" v-else>
      <div class="header-left">
        <div class="tile-icon hide-sm">
          <figure class="avatar" @click="goToPatientProfile">
            <img :src="patientImage" :alt="patient.name">
          </figure>
        </div>
        <div class="tile-content">
          <div>
            <span v-if="patient.socialName">
              <strong>{{ patient.socialName }}</strong>
              <span> ({{ patient.name }})</span>
            </span>
            <strong v-else>{{ patient.name }}</strong>
            <span class="ml-1">
              <span class="text-info" v-if="insuranceName">[{{ insuranceName }}]</span>
              <span class="text-error text-bold" v-else>[Sem convênio definido]</span>
            </span>
            <br>
            <span class="text-small">
              Nascimento: {{ patient.birthDate | date }} ({{ patient.birthDate | dateOld(false) }})
            </span>
            <small v-if="isMinor && patient.motherName">
              - Nome da mãe: {{ patient.motherName }}
            </small>
          </div>
          <button class="btn btn-sm btn-neutral mt-1 mr-1 hide-sm"
                  @click="patientModal.show = true">
            Mais informações
          </button>
          <button class="btn btn-sm mt-1 hide-sm"
                  :class="patient.allergy ? 'btn-warning' : 'btn-neutral'"
                  @click="allergyModal.show = true">
            {{ patient.allergy ? 'Paciente com alergia(s)' : 'Informar alergia(s)' }}
          </button>
        </div>
      </div>
      <div class="header-center">
        <slot name="center"></slot>
      </div>
      <div class="header-right">
        <slot name="right"></slot>
      </div>
    </div>
    <patient-view
      v-if="patientModal.show"
      :patient-id="patient.id"
      :show="patientModal.show"
      @close="patientModal.show = false"
    />
    <allergy
      v-if="allergyModal.show"
      :show="allergyModal.show"
      :id="patient.id"
      @close="closeAllergyModal"
    />
  </div>
</template>

<script>
import moment from 'moment';
import PatientView from '../../../patient/modals/View.vue';
import Allergy from '../Allergy.vue';

export default {
  components: {
    Allergy,
    PatientView,
  },
  props: {
    patient: {
      type: Object,
    },
    appointment: {
      type: Object,
    },
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      patientModal: {
        show: false,
      },
      allergyModal: {
        show: false,
      },
    };
  },
  methods: {
    goToPatientProfile() {
      this.$router.push(`/patients/${this.patient.id}/edit`);
    },
    closeAllergyModal() {
      this.allergyModal.show = false;
      this.$emit('allergy-updated');
    },
  },
  computed: {
    insuranceName() {
      if (!this.appointment || !this.patient) {
        return 'Convênio não encontrado';
      }

      return this.appointment?.insuranceName
        ? this.appointment.insuranceName
        : this.patient.insuranceName;
    },
    bgImage() {
      if (!this.patient.gender) {
        return null;
      }

      let backgroundImage = `url('//static.stenci.pro/images/no-image-${
        this.patient.gender}.png')`;

      if (this.image.preview) {
        backgroundImage = `url('${this.image.preview}')`;
      } else if (this.patient.imageUrl) {
        backgroundImage = `url('${this.patient.imageUrl}?w=200&h=200')`;
      }

      return { backgroundImage };
    },
    patientImage() {
      if (!this.patient || !this.patient.gender) {
        return null;
      }

      return this.patient.imageUrl
        ? `${this.patient.imageUrl}?w=200&h=200`
        : `//static.stenci.pro/images/no-image-${this.patient.gender}.png`;
    },
    isMinor() {
      if (this.patient.birthDate) {
        const duration = moment.duration(moment().diff(moment(this.patient.birthDate))).asYears();
        return duration < 18;
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";

.medical-record-header {
  align-items: center;
  display: flex;

  .header-grid {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    width: 100%;
    gap: $layout-spacing-lg;
    padding: 0 $layout-spacing-lg;

    @media screen and (max-width: $size-sm) {
      grid-template-columns: minmax(0, 1fr) auto;
      gap: $layout-spacing;
    }
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: $layout-spacing;
  }

  .header-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .header-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: $layout-spacing;

    @media screen and (max-width: $size-sm) {
      flex-wrap: wrap;
      grid-column: 1 / -1;
      justify-content: flex-start;
    }
  }

  .tile {
    flex: 1;
    padding: 0;
  }

  .tile-content {
    flex: 1;
  }

  .avatar {
    height: 2.5rem;
    width: 2.5rem;
    cursor: pointer;
    transition: opacity 0.2s ease;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
